import { render, staticRenderFns } from "./CardButton.vue?vue&type=template&id=0909ed10&scoped=true&"
import script from "./CardButton.vue?vue&type=script&lang=js&"
export * from "./CardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0909ed10",
  null
  
)

export default component.exports